import { fontWeights } from "@/utils/fonts";
import Image from "next/image";

interface MeetingImgProps {
    text: string;
    image: string;
}
export function MeetingImg({ text, image }: MeetingImgProps) {
    return (
        <div className="relative w-full" style={{ aspectRatio: "1920 / 600" }}>
            <div className="absolute inset-0 bg-black/20 z-10" />
            <Image
                src={image}
                alt={text}
                fill
                className="object-cover"
                sizes="(max-width: 1920px) 100vw, 1920px"
                loading="lazy"
                decoding="async"
            />
            <div className="absolute inset-0 z-20 flex items-center justify-center">
                <h1
                    className="text-[15px]  sm:text-[20px] lg:text-[30px] xl:text-[40px] 2xl:text-[50px] font-bold text-white text-center"
                    style={{ fontFamily: "Asap", fontWeight: fontWeights.asap.bold }}
                >
                    {text}
                </h1>
            </div>
        </div>
    );
}
